import React from 'react';
import styled from 'styled-components'
import TimelineItem from './TimelineItem'
import Carousel from 'react-slick'

const Container = styled.div`
position:relative;
direction:ltr;
`
const StyledLine = styled.div`
position: absolute;
top:11px;
right:0;
left:0;
height:2px;
background-color: #fff;
`

const TimelineList = (props) => {
    return (
        <Container>
            <StyledLine />
            <Carousel {...props.settings} ref={props.nodeHandler}>
                {props.items.map((i, idx) =>
                    <div key={idx}>
                        <TimelineItem
                            idx={idx}
                            active={i.active}
                            year={i.year}
                            onClick={props.onItemClick}
                            onLoad={props.onItemLoad}
                        />
                    </div>
                )}
            </Carousel>
        </Container>
    );
}

export default TimelineList;


// WEBPACK FOOTER //
// ./src/components/TimelineList.jsx